import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { useI18n } from "@/contexts/I18nContext";

const STORAGE_KEY = "crv_cookie_consent_v1";

function updateConsent(state) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  window.gtag("consent", "update", {
    ad_storage: state,
    ad_user_data: state,
    ad_personalization: state,
    analytics_storage: state,
  });
}

export default function CookieBanner() {
  const { t, locale } = useI18n();
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (!stored) {
        setVisible(true);
      } else {
        const parsed = JSON.parse(stored);
        updateConsent(parsed.consent === "granted" ? "granted" : "denied");
      }
    } catch (e) {
      setVisible(true);
    }
  }, []);

  const persist = (choice) => {
    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify({ consent: choice, ts: Date.now() })
      );
    } catch (e) {}
    updateConsent(choice);
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      data-testid="cookie-banner"
      role="dialog"
      aria-live="polite"
      className="fixed inset-x-0 bottom-0 z-50 border-t border-[#0A192F]/10 bg-white shadow-[0_-8px_24px_rgba(10,25,47,0.08)]"
    >
      <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-5">
        <div className="flex flex-col lg:flex-row lg:items-center gap-4 lg:gap-8">
          <div className="flex-1">
            <p className="font-heading text-sm font-semibold text-[#0A192F]">
              {t("cookie.title")}
            </p>
            <p className="mt-1 text-xs leading-relaxed text-[#334155]">
              {t("cookie.message")}{" "}
              <Link
                data-testid="cookie-learn-more"
                to={`/${locale}/cookies`}
                className="underline text-[#047857] hover:text-[#0A192F]"
              >
                {t("cookie.learnMore")}
              </Link>
            </p>
          </div>
          <div className="flex flex-col sm:flex-row gap-2">
            <button
              data-testid="cookie-reject"
              onClick={() => persist("denied")}
              className="rounded-sm border border-[#0A192F]/20 px-4 py-2 text-xs font-semibold uppercase tracking-wider text-[#0A192F] hover:bg-[#0A192F] hover:text-white"
            >
              {t("cookie.reject")}
            </button>
            <button
              data-testid="cookie-accept"
              onClick={() => persist("granted")}
              className="rounded-sm bg-[#059669] px-4 py-2 text-xs font-semibold uppercase tracking-wider text-white hover:bg-[#047857]"
            >
              {t("cookie.accept")}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
